"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleLabel = exports.ToggleInput = exports.ToggleContainer = exports.Slider = exports.Label = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../assets/styles/colors");
const media_1 = require("../../../utils/media");
const ToggleLabel = styled_components_1.default.label `
  position: relative;
  display: inline-block;
  width: 3.6rem;
  height: 1.8rem;

  @media ${media_1.media.mobile} {
    width: ${(props) => (props.$biggerMobileVersion ? "3.6rem" : "2.5rem")};
    height: ${(props) => (props.$biggerMobileVersion ? "1.8rem" : "1.3rem")};
  }
`;
exports.ToggleLabel = ToggleLabel;
const ToggleInput = styled_components_1.default.input `
  opacity: 0;
  width: 3.6rem;
  height: 1.8rem;
  z-index: 2;
  position: relative;

  &:checked + span:before {
    transform: translateX(1.8rem);

    @media ${media_1.media.mobile} {
      transform: ${(props) => props.$biggerMobileVersion
    ? "translateX(1.8rem)"
    : "translateX(1.2rem)"};
    }
  }

  @media ${media_1.media.mobile} {
    width: ${(props) => (props.$biggerMobileVersion ? "3.6rem" : "2.5rem")};
    height: ${(props) => (props.$biggerMobileVersion ? "1.8rem" : "1.3rem")};
  }
`;
exports.ToggleInput = ToggleInput;
const Slider = styled_components_1.default.span `
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${(props) => props.$variant === "toggle" && !props.$isActive ? colors_1.gray600 : colors_1.blue};
  transition: 0.4s;
  border-radius: 30px;
  z-index: 1;

  &:before {
    position: absolute;
    content: "";
    height: 1.4rem;
    width: 1.4rem;
    left: 0.2rem;
    bottom: 0.2rem;
    background-color: ${colors_1.white};
    transition: 0.4s;
    border-radius: 50%;

    @media ${media_1.media.mobile} {
      height: ${(props) => (props.$biggerMobileVersion ? "1.4rem" : "0.9rem")};
      width: ${(props) => (props.$biggerMobileVersion ? "1.4rem" : "0.9rem")};
      left: 0.18rem;
      bottom: 0.18rem;
    }
  }
`;
exports.Slider = Slider;
const Label = styled_components_1.default.span `
  color: ${(props) => (props.$isActive ? colors_1.acBlueDark : colors_1.gray400)};
  display: inline-block;
  align-items: center;
  gap: 1rem;

  &::first-letter {
    text-transform: capitalize;
  }
`;
exports.Label = Label;
const ToggleContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  gap: 1rem;
  z-index: 0;
`;
exports.ToggleContainer = ToggleContainer;
